import { combineReducers } from 'redux';
import authenticationReducer from '../redux/Authentication/reducer';
import claimsReducer from '../redux/Claims/reducer';
import policyDetailsReducer from '../redux/PolicyDetails/reducer';
import servicesReducer from '../redux/Services/reducer';

const reducers = {
  authentication: authenticationReducer,
  claims: claimsReducer,
  policyDetails: policyDetailsReducer,
  services: servicesReducer,
};

const rootReducers = combineReducers(reducers);

export default rootReducers;
